import { loanRequestsApi } from 'app/services/api';

import { GROUP_ITEMS_PAGE_SIZE, GroupItemsStatus } from '../../VendorRequestDetailDrawer.constants';

export const INITIAL_STATE = { items: [], totalCount: 0, status: GroupItemsStatus.IDLE };

export const EMPTY_ITEM_FILTERS = {};

const buildItemSearchFilter = ({ operationType, statusIds, vendorRequestId } = {}) => ({
  ...(operationType?.trim() ? { operationTypeContains: operationType.trim() } : {}),
  ...(statusIds?.length ? { statuses: statusIds } : {}),
  ...(vendorRequestId?.trim() ? { vendorRequestIds: [vendorRequestId.trim()] } : {}),
});

export const fetchCorrelatedPage = async ({ applicationId, correlationId, skip, itemFilters }) => {
  const { data } = await loanRequestsApi.searchLoanRequests({
    applicationIds: [applicationId],
    correlationIds: [correlationId],
    skip,
    take: GROUP_ITEMS_PAGE_SIZE,
    ...buildItemSearchFilter(itemFilters),
  });

  return { items: data?.items ?? [], totalCount: data?.totalCount ?? 0 };
};

export const fetchUncorrelatedItem = async groupKey => {
  const { data } = await loanRequestsApi.getLoanRequest(groupKey);

  return { items: data ? [data] : [], totalCount: data ? 1 : 0 };
};
